import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './CompareTable.css'

const filterOutBadChildren = children => {
  return children.filter(value => typeof value === 'object')
}

let keyCounter = 0
const getTableKey = () => `compare-table-body-${keyCounter++}`

class CompareTable extends Component {
  getHeadingRowInfo(tableHeadChildren) {
    const filtered = filterOutBadChildren(tableHeadChildren)
    const filteredRow = filterOutBadChildren(filtered[0].props.children)
    return {
      left: filteredRow[1].props.children[0].props.children[0],
      right: filteredRow[2].props.children[0].props.children[0]
    }
  }

  render() {
    let Sticky
    let StickyContainer
    if (this.props.readOnly) {
      Sticky = GenericContainer
      StickyContainer = GenericContainer
    } else {
      try {
        console.log(require.resolve('react-sticky')) // Prevents errors in dev tools
        const ReactSticky = require('react-sticky')
        Sticky = ReactSticky.Sticky
        StickyContainer = ReactSticky.StickyContainer
      } catch (e) {
        Sticky = GenericContainer
        StickyContainer = GenericContainer
      }
    }

    try {
      const filteredTableGroupParts = filterOutBadChildren(this.props.children)
      const tableGroup = filteredTableGroupParts.filter(
        value => value.type === 'tgroup'
      )

      const filteredTableParts = filterOutBadChildren(
        tableGroup[0].props.children
      )
      const tableHead = filteredTableParts.filter(
        value => value.type === 'thead'
      )
      const tableBody = filteredTableParts.filter(
        value => value.type === 'tbody'
      )

      const columnText = this.getHeadingRowInfo(tableHead[0].props.children)

      const headTextClasses = classNames(
        'hw-compare-head-text',
        styles.headCellText
      )

      return (
        <StickyContainer className={styles.compare}>
          <Sticky className={`hw-compare-head-row`}>
            <div className={`${styles.headCellVisibleWrapper}`}>
              <span className={`${styles.headCell} hw-compare-head-cell`}>
                <span
                  aria-hidden
                  role="presentation"
                  className={headTextClasses}
                >
                  {columnText.left}
                </span>
              </span>
              <span className={`${styles.headCell} hw-compare-head-cell`}>
                <span
                  aria-hidden
                  role="presentation"
                  className={headTextClasses}
                >
                  {columnText.right}
                </span>
              </span>
            </div>
            <div
              aria-hidden
              role="presentation"
              className={styles.headCellVisibleUnderscore}
            >
              {' '}
            </div>
          </Sticky>
          <table className={styles.compareTable}>
            <CompareHeaderRowForA11y columnText={columnText} />
            <CompareTableBody>{tableBody[0].props.children}</CompareTableBody>
          </table>
        </StickyContainer>
      )
    } catch (err) {
      console.error(err)
      return (
        <table className={styles.compareTable}>{this.props.children}</table>
      )
    }
  }
}

class CompareHeaderRowForA11y extends Component {
  render() {
    const { columnText } = this.props
    const headCellClasses = classNames(
      styles.forAssistiveTech,
      styles.headCellText
    )

    return (
      <thead>
        <tr
          className={styles.forFixedWidthLayoutRow}
          aria-hidden
          role="presentation"
        >
          <td aria-hidden role="presentation">
            {' '}
          </td>
          <td
            aria-hidden
            role="presentation"
            className={styles.forFixedWidthLayout}
          >
            {' '}
          </td>
          <td
            aria-hidden
            role="presentation"
            className={styles.forFixedWidthLayout}
          >
            {' '}
          </td>
        </tr>
        <tr className={styles.forAssistiveTech}>
          <td aria-hidden role="presentation" key="compare-table-head-0">
            {''}
          </td>
          <th
            scope="col"
            className={styles.headCell}
            key="compare-table-head-1"
          >
            <span className={headCellClasses}>{columnText.left}</span>
          </th>
          <th
            scope="col"
            className={styles.headCell}
            key="compare-table-head-2"
          >
            <span className={headCellClasses}>{columnText.right}</span>
          </th>
        </tr>
      </thead>
    )
  }
}

class CompareTableBody extends Component {
  getRow(rowCells) {
    const cells = []
    const rowHeader = rowCells.shift()
    const headerChildren = filterOutBadChildren(rowHeader.props.children)

    const compareTableCellClasses = classNames('compareTableCell', styles.cell)
    const titleRowClasses = classNames(
      'sectionTitleRow',
      styles.sectionTitleRow
    )
    const titleCellClasses = classNames(
      'sectionTitleCell',
      styles.sectionTitleCell
    )

    for (const cell of rowCells) {
      const cellElements = filterOutBadChildren(cell.props.children)
      cells.push(
        <td className={compareTableCellClasses} key={getTableKey()}>
          {cellElements}
        </td>
      )
    }

    return [
      <tr className={titleRowClasses} key={getTableKey()} aria-hidden>
        <td className={styles.forAssistiveTech} key={getTableKey()}>
          {' '}
        </td>
        <td className={titleCellClasses} key={getTableKey()} colSpan="2">
          <span className={styles.sectionTitleParent}>{headerChildren}</span>
        </td>
      </tr>,
      <tr key={getTableKey()}>
        <th className={styles.forAssistiveTech} scope="row" key={getTableKey()}>
          {headerChildren.filter(node => typeof node.type === 'function')}
        </th>
        {cells}
      </tr>
    ]
  }

  render() {
    let rows = []
    const { children } = this.props
    const filteredRows = filterOutBadChildren(children)

    for (const filteredRow of filteredRows) {
      const filteredCells = filterOutBadChildren(filteredRow.props.children)
      rows.push(this.getRow(filteredCells))
    }

    return <tbody>{rows}</tbody>
  }
}

class GenericContainer extends Component {
  render() {
    const { children, ...attributes } = this.props
    return <div {...attributes}>{children}</div>
  }
}

CompareTable.propTypes = {
  children: PropTypes.node,
  readOnly: PropTypes.bool
}

CompareHeaderRowForA11y.propTypes = {
  columnText: PropTypes.shape({
    left: PropTypes.string.isRequired,
    right: PropTypes.string.isRequired
  }).isRequired
}

CompareTableBody.propTypes = {
  children: PropTypes.array
}

GenericContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default CompareTable



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/CompareTable/index.js